import React, { useEffect, useMemo } from 'react'
import KanBoIcon from 'components/KanBoIcon'
import menuItemClasses from 'components/Menu/components/MenuItem/MenuItem.module.scss'
import { FormattedMessage, useIntl } from 'react-intl'
import sweetalert from 'sweetalert2'
import Clipboard from 'react-clipboard.js'
import { useSelector, useDispatch } from 'react-redux'
import fetchIncomingMails from '../../sagas/fetchIncomingMails'
import { createSelector } from 'reselect'
import {
  MenuItem as ModalMenuItem
} from 'components/Menu'
import AddAddress from '../../Sidebar/Settings/components/IncomingEmails/AddAddress'
import { navigationController } from 'components/Modal'
import { useCardContext } from 'dataProviders/Card'

const GetIncomingMailPublicAddress: React.FC<{ onClick?: () => void }> = ({
  onClick
}) => {
  const intl = useIntl()

  const dispatch = useDispatch()

  const cardContext = useCardContext()

  const { push } = navigationController.useActions()

  const incomingMailsLoading = useSelector(state => state['view-card'].incomingMails[cardContext.id].isLoading)

  const incomingMailsLoaded = useSelector(state => state['view-card'].incomingMails[cardContext.id].isLoaded)

  const incomingMailsDomain = useSelector<any>(state => state.kanbo.config.incomingMailDomain)

  const publicIncomingMailName = useSelector<any>(useMemo(() => createSelector(
    [
      state => state.kanbo.incomingMails.names,
      state => state.kanbo.incomingMails.byName,
    ],
    (
      incomingMailNames,
      incomingMailsByName,
    ) =>
      incomingMailNames.find(name => incomingMailsByName[name].cardId === cardContext.id)
  ), [cardContext.id]))

  useEffect(() => {
    if (!incomingMailsLoading && !incomingMailsLoaded) {
      dispatch(fetchIncomingMails({
        cardId: cardContext.id
      }))
    }
  }, [incomingMailsLoading, incomingMailsLoaded])

  if (!publicIncomingMailName) {
    return (
      <ModalMenuItem
        icon={<KanBoIcon name='kanbo-16-incoming-mail' />}
        onClick={() => {
          sweetalert({
            type: 'info',
            text: intl.formatMessage({ id: 'INCOMING_EMAILS_CARD_ADDRESS_GET_NOT_CREATED' }),
            confirmButtonText: intl.formatMessage({ id: 'YES' }),
            cancelButtonText: intl.formatMessage({ id: 'NO' }),
            showCancelButton: true,
          }).then(() => {
            push((props) => <AddAddress {...props} cardId={cardContext.id} />)
          }).catch(sweetalert.noop)

          onClick?.()
        }}
      >
        <FormattedMessage id='INCOMING_EMAILS_CARD_ADDRESS_GET' />
      </ModalMenuItem>
    )
  }

  return (
    <li
      onClick={onClick}
    >
      <Clipboard
        component='a'
        data-clipboard-text={`${publicIncomingMailName}@${incomingMailsDomain}`}
        onSuccess={() => {
          sweetalert({
            type: 'success',
            text: intl.formatMessage({ id: 'LINK_COPIED_TO_CLIPBOARD' }),
            timer: 1000,
            showConfirmButton: false
          }).catch(sweetalert.noop)
        }}
      >
        <KanBoIcon name='kanbo-16-incoming-mail' className={menuItemClasses.icon} />
        <FormattedMessage id='INCOMING_EMAILS_CARD_ADDRESS_GET' />
      </Clipboard>
    </li>
  )
}

export default GetIncomingMailPublicAddress
